// dependencies
import { List, Map } from "immutable";

// selectors
import { getUI } from "Selectors/ui";

export const getGraphWidth = (state) => getUI(state).getIn(["graphWidth"], 0);
export const getMeanResponseTime = (state) => getUI(state).getIn(["requestsPerMinute"], List());
export const getRequestsPerMinute = (state) => getUI(state).getIn(["requestsPerMinute"], List());
export const getEnvironmentRequestCount = (state) => getUI(state).getIn(["environmentRequestCount"], 0);
export const getEnvironmentCompanyCount = (state) => getUI(state).getIn(["environmentCompanyCount"], 0);
export const getEnvironmentActiveUserCount = (state) => getUI(state).getIn(["environmentActiveUserCount"], 0);
export const getEnvironmentTotalUserCount = (state) => getUI(state).getIn(["environmentTotalUserCount"], 0);
export const getEnvironmentMeanResponseTime = (state) => getUI(state).getIn(["environmentMeanResponseTime"], 0);
export const getEnvironmentBranch = (state, environment) =>
	getUI(state).getIn(["environmentBranches", environment], Map({ hash: "", branch: "" }));

/**
 * Selectors for the graph selection object
 */
export const getPagesize = (state) => getUI(state).getIn(["pageSize"], 50);
export const graphSelectionRange = (state) => getUI(state).getIn(["graphSelectionRange"], List());
export const getGraphSelectionTotalCount = (state) => getUI(state).getIn(["graphSelection", "count"], 0);
export const getGraphSelectionRequests = (state) => getUI(state).getIn(["graphSelection", "requests"], List());
export const getGraphSelectionCurrentPage = (state) => getUI(state).getIn(["graphSelection", "currentPage"], 0);
export const getGraphSelectionRangeIndexes = (state) => getUI(state).getIn(["graphSelectionRangeIndexes"], List());
